import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { AccessLog, AccessLogListResponse, AccessLogQueryParams, CreateAccessLog } from '@frontend/user/types';

export class AccessLogClient extends APIClient {
    public static readonly endpoint = '/user-api/v1';

    public static async fetchAccessLogs(queryParams?: ApiQueryParams<DefaultQueryParams | AccessLogQueryParams>): Promise<AccessLogListResponse> {
        return this.apiPaginated<AccessLogListResponse, DefaultQueryParams | AccessLogQueryParams>(`${this.endpoint}/access-logs`, queryParams);
    }

    public static async postSpotAccessLog(spotId: string, accessLog: CreateAccessLog): Promise<AccessLog> {
        const response = await this.post(`${this.endpoint}/spots/${spotId}/access-logs`, accessLog);
        return await this.handleResponse<AccessLog>(response);
    }

    public static async fetchSpotAccessLog(spotId: string, accessLogId: string): Promise<AccessLog> {
        const response = await this.fetch(`${this.endpoint}/spots/${spotId}/access-logs/${accessLogId}`);
        return await this.handleResponse<AccessLog>(response);
    }

    public static async deleteSpotAccessLog(spotId: string, accessLogId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/spots/${spotId}/access-logs/${accessLogId}`);
        return await this.handleVoidResponse(response);
    }
}
